import { schema } from "normalizr";

const DEFAULT_OPTS = {
  idAttribute: "id"
};
export const diagnostic = new schema.Entity("diagnostics", {}, DEFAULT_OPTS);
// same as diagnostics, however contains previous questions and answers
export const diagnosticSession = new schema.Entity(
  "diagnosticSessions",
  {},
  DEFAULT_OPTS
);
export const question = new schema.Entity("questions", {}, DEFAULT_OPTS);
export const painZone = new schema.Entity("painZones", {}, DEFAULT_OPTS);
export const helpText = new schema.Entity(
  "helpTexts",
  {},
  { ...DEFAULT_OPTS, idAttribute: "key" }
);



// WEBPACK FOOTER //
// ./src/modules/entity-repository/schema.js